import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { isNullOrUndefined } from '@app/util/util';
import { ProvincesAndCitiesExternal } from '@app/entities/provinces-cities';

declare const external_file_city_relations;
declare const external_file_provinces;

@Injectable()
export class ProvincesAndCitiesExternalService {

  constructor() { }

  public fetchProvincesAndCitiesRelation(): Observable<ProvincesAndCitiesExternal> {
    if (!isNullOrUndefined(external_file_city_relations) && !isNullOrUndefined(external_file_provinces)) {
      return of({
        CitiesRelation: external_file_city_relations,
        Provinces: external_file_provinces
      });
    } else {
      return of({
        CitiesRelation: [],
        Provinces: [],
      });
    }
  }

}
